import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-truncated kn-flex-05 p-ml-2 p-text-right" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-link kn-flex-05",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = { class: "kn-truncated kn-flex-05 p-ml-2 p-text-left" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_MetawebBusinessViewDialog = _resolveComponent("MetawebBusinessViewDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.businessModel.joinRelationships,
      class: "p-datatable-sm kn-table p-ml-2",
      responsiveLayout: "scroll",
      breakpoint: "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, { class: "p-text-center" }, {
          header: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('metaweb.businessModel.editJoin'),
              class: "p-button-link p-text-right",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBusinessViewDialog = true))
            }, null, 8, ["label"])
          ]),
          body: _withCtx((slotProps) => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.sourceColumns, (rel, index) => {
              return (_openBlock(), _createBlock("span", {
                key: index,
                class: "associator-block-hover p-d-flex p-flex-row p-ai-center kn-width-full"
              }, [
                _createVNode("span", _hoisted_1, _toDisplayString(slotProps.data.sourceTable.name) + "." + _toDisplayString(rel.name), 1),
                _hoisted_2,
                _createVNode("span", _hoisted_3, _toDisplayString(slotProps.data.destinationTable.name) + "." + _toDisplayString(slotProps.data.destinationColumns[index].name), 1),
                _hoisted_4
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    (_ctx.showBusinessViewDialog)
      ? (_openBlock(), _createBlock(_component_MetawebBusinessViewDialog, {
          key: 0,
          selectedBusinessModel: _ctx.selectedBusinessModel,
          physicalModels: _ctx.propMeta.physicalModels,
          meta: _ctx.propMeta,
          observer: _ctx.observer,
          editMode: true,
          showBusinessViewDialog: _ctx.showBusinessViewDialog,
          onCloseDialog: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showBusinessViewDialog = false))
        }, null, 8, ["selectedBusinessModel", "physicalModels", "meta", "observer", "showBusinessViewDialog"]))
      : _createCommentVNode("", true)
  ], 64))
}